import { updateFirestoreData } from "global/firestoreData/updates/dataUpdates";
import { updateLinkHelpers } from "global/firestoreData/updates/subUpdates/fsUpdate_dataLInks";
import _ from "lodash";
import { useCallback, useContext } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { LogContext } from "../LogContext";
import { ParentContext } from "../ParentContext";
import { createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { _globalCollectionName } from "projectSpecific/sports/dbActions/globals";

export const useFirestoreUpdate = ({ dataUpdateType = null } = {}) => {

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, appUser_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { appSettings_fns, page_fns } = fns ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataRestrictions, appDataSource } = aps_global ?? {}
  const { mainDb, mainStorage } = app_state ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}

  const { appUser, appUsers } = appUser_state ?? {}

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const updateFsData = useCallback(
    async ({
      vit,
      data_modified,
      data_original,
      selectedDataItems,
      staticViewKeys,
      swipedItem,
      appDataDocs,
      callback
    }) => {
      const cb = (res) => {
        callback(res)
      }
      const { autoUpdateCollectionRelationships } = appDataSource ?? {}
      const opts = {}
      const ufProps = {
        appDataDocs,
        appDataSource,
        autoUpdateCollectionRelationships,
        data_original,
        dataUpdateType: dataUpdateType,
        relatedDocsToUpdate: null,
        id: data_modified?.id || null,
        itemData: data_modified,
        mainStorage,
        modifyType: dataUpdateType,
        selectedDataItems: selectedDataItems,
        staticViewKeys,
        swipedItem,
        vit: vit,
      }

      const _appDataDocuments = _.cloneDeep(appDataDocuments)
      const appDataDocument = _appDataDocuments?.[vit]
      const appDataDoc = appDataDocument?.[data_modified?._itemKey]

      const relatedDocsToUpdate = updateLinkHelpers.getDocsToUpdate({
        vit: vit,
        prevItem: appDataDoc,
        nextItem: data_modified,
        appDatas: _appDataDocuments
      })

      ufProps.relatedDocsToUpdate = relatedDocsToUpdate

      return updateFirestoreData(cb, paps_state, ufProps, page_fns, appUser, dataRestrictions, opts, database_fns, appSettings_fns, mainDb, fn_cls, mainStorage)
    },
    []
  );

  const updateGlobal = useCallback(
    async ({
      dataList,
      globalName,
      callback
    }) => {
      const cb = (res) => {
        callback(res)
      }
      const { pathViews } = paps_state
      const _refPath = createRefPath_event(pathViews, [_globalCollectionName, globalName])
      database_fns.set_doc(_refPath, dataList, true, cb)
    },
    []
  );

  const updateGlobals = useCallback(
    async ({
      data,
      callback
    }) => {
      const cb = (res) => {
        callback(res)
      }
      Object.keys(data).forEach(key => {
        const _refPath = createRefPath_event(pathViews, [_globalCollectionName, key])
        database_fns.set_doc(_refPath, data[key], true)
      })
    },
    []
  );

  return {
    updateFsData,
    updateGlobal,
    updateGlobals,
  };
};
